import React from "react";
import { Box, BoxProps } from "theme-ui";

interface DividerProps extends BoxProps {}

export const Divider: React.FC<DividerProps> = ({ variant = "divider.base", ...rest }) => {
  return <Box variant={variant} />;
};
